import { CURIE_DEPLOYMENTS_VERSION, GITHUB_TAG, SDK_CURIE_VERSION, SEGMENT_API_KEY } from "constant/envVariables"

export enum EventGroup {
    CONTRACT = "CONTRACT", // NOTE: for things that happens on-chain.
    INTERACTION = "INTERACTION", // NOTE: for things that user does actively to the user interface.
    UI_FEEDBACK = "UI_FEEDBACK", // NOTE: for changes on the user interface passively.
}

export enum EventTypeContract {
    TX_SENT = "TX_SENT",
    TX_SUCCEEDED = "TX_SUCCEEDED",
    TX_REJECTED = "TX_REJECTED",
    TX_FAILED = "TX_FAILED",
}

export enum EventTypeInteraction {
    BUTTON_CLICKED = "BUTTON_CLICKED",
    INPUT_FOCUSED = "INPUT_FOCUSED",
    INPUT_UNFOCUSED = "INPUT_UNFOCUSED",
    FORM_SUBMITTED = "FORM_SUBMITTED",
    TAB_FOCUSED = "TAB_FOCUSED",
    RADIO_GROUP_SELECTED = "RADIO_GROUP_SELECTED",
    MODAL_OPENED = "MODAL_OPENED",
    MODAL_CLOSED = "MODAL_CLOSED",
    LINK_CLICKED = "LINK_CLICKED",
    MENU_ITEM_CLICKED = "MENU_ITEM_CLICKED",
    SLIDER_CHANGED_ENDED = "SLIDER_CHANGED_ENDED",
    OTHERS = "OTHERS",
}

export enum EventTypeUIFeedback {
    SUCCESS_DISPLAYED = "SUCCESS_DISPLAYED",
    WARNING_DISPLAYED = "WARNING_DISPLAYED",
    ERROR_DISPLAYED = "ERROR_DISPLAYED",
    INFO_DISPLAYED = "INFO_DISPLAYED",
}

export type EventType = EventTypeContract | EventTypeInteraction | EventTypeUIFeedback

export interface TrackEventProperties {
    eventName: string // NOTE: UID for the event.
    eventType?: EventType
    module?: string // NOTE: Feature grouping.
    component?: string // NOTE: UI component.
    description?: string // NOTE: In case multiple instance exists on the same url, add this to differentiate.
    versionFrontend?: string
    versionContractCore?: string
    versionSDK?: string
    payload?: { [key: string]: string | number | boolean } // NOTE: Custom fields for the event.
}

interface TrackEventPropertiesContract extends TrackEventProperties {
    eventType?: EventTypeContract
    transactionId?: string
}
interface TrackEventPropertiesInteraction extends TrackEventProperties {
    eventType?: EventTypeInteraction
}
interface TrackEventPropertiesUIFeedback extends TrackEventProperties {
    eventType?: EventTypeUIFeedback
}

export interface TrackingProperties {
    [attribute: string]: number | string
}
class SegmentService {
    static instance?: SegmentService

    constructor(
        readonly writeKey?: string,
        readonly versionFrontend?: string,
        readonly versionContractCore?: string,
        readonly versionSDK?: string,
    ) {
        if (SegmentService.instance) {
            return SegmentService.instance
        }
        SegmentService.instance = this
    }

    init() {
        if (!this.writeKey) {
            console.warn("Segment writeKey is not provided.")
            return
        }
        analytics.load(this.writeKey)
        analytics.track("App Start", { version: this.versionFrontend })
    }

    identify(account: string) {
        analytics.identify(account)
    }

    page(pageInfo?: TrackingProperties) {
        analytics.page(pageInfo)
    }

    track(eventGroup: EventGroup.CONTRACT, properties: TrackEventPropertiesContract): void
    track(eventGroup: EventGroup.INTERACTION, properties: TrackEventPropertiesInteraction): void
    track(eventGroup: EventGroup.UI_FEEDBACK, properties: TrackEventPropertiesUIFeedback): void
    track(eventGroup: EventGroup, properties: TrackEventProperties) {
        const props: TrackEventProperties = {
            versionFrontend: this.versionFrontend,
            versionContractCore: this.versionContractCore,
            versionSDK: this.versionSDK,
            ...properties,
        }
        analytics.track(eventGroup, props)
    }

    reset() {
        analytics.reset()
    }
}

const segmentService = new SegmentService(SEGMENT_API_KEY, GITHUB_TAG, CURIE_DEPLOYMENTS_VERSION, SDK_CURIE_VERSION)
export default segmentService
